import React from 'react';
import { useSelector } from 'react-redux';
import './total-selling-price.scss';
import cn from 'classnames';
import { GiCheckMark } from 'react-icons/gi';
import { formatCurrency } from '@/utilities/CompareVehicleUtils.jsx';
import { AiOutlineArrowUp } from 'react-icons/ai';

const TotalSellingPriceSection = ({
  contracts,
  lowestBidData,
  networkCostBreakDownData,
}) => {
  const {
    contract: selectedContract,
  } = useSelector((state) => state.reviewReducer);
  const activateLowestBid = (contract) => {
    return contract?.contractLineId === lowestBidData?.contractLineId
      ? 'lowest-bid'
      : '';
  };

  return (
    <>
      <div className="afp-store-total-selling-price">
        <table className="usa-table full-width-table" role="presentation">
          <tbody>
            <tr>
              <td
                data-testid="total-sale-price-cell"
                className="total-sale-price-title-cell"
              >
                Total selling price:
              </td>
              {networkCostBreakDownData?.map((contract) => {
                const contractFragmentKey = `${contract?.contractLineId}`;
                const unBuildableInfo = contract?.isUnBuildable;
                return (
                  <React.Fragment key={contractFragmentKey}>
                    <td
                      data-testid={`${contract?.contractLineId}-total-sale-price`}
                      key={`${contract?.contractLineId}-total-sale-price`}
                      className={cn(
                        'contract-cell',
                        activateLowestBid(contract),
                      )}
                    >
                      {formatCurrency(contract?.totalSellingPrice)}{' '}
                      {unBuildableInfo ? '*' : ''}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>
            <>
              {selectedContract && Object.keys(selectedContract).length ? (
                <tr>
                  <td
                    aria-label="td"
                    data-testid="start-requisition"
                    className="total-sale-price-title-cell requisition"
                  />
                  {contracts.map((contract) => {
                    return (
                      <td
                        data-testid={`${contract.contractLineId}-pre-selected-vendors`}
                        className="pre-selected-vendors"
                      >
                        {selectedContract?.contractLineId ===
                          contract.contractLineId && (
                          <>
                            {contract.contractLineId ===
                              lowestBidData.contractLineId && (
                              <span className="selected-vendor-container lowest-bid-container">
                                <GiCheckMark />
                                <span className="selected-vendor-title">
                                  LOWEST BID
                                </span>
                              </span>
                            )}
                            <span className="selected-vendor-container">
                              <AiOutlineArrowUp />
                              <span className="selected-vendor-title">
                                SELECTED VENDOR
                              </span>
                            </span>
                          </>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ) : null}
            </>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TotalSellingPriceSection;